const userData = {
  gender: "",
  age: "",
  weight: "",
  height: "",
  activity: "",
  meals: "",
  goal: "",
  calories: "",
  proteins: "",
  carbs: "",
  fat: "",
  goalCalories: "",
  genderVal: "",
  proteinPercentage: "",
  carbsPercentage: "",
  fatPercentage: "",
  isBlocked: true
};

export default userData;
